import './style.css';
import logo from '../../assets/icons/logo-footer.svg';
import logoFacebook from '../../assets/images/facebook-logo.png';
import logoInstagram from '../../assets/images/instagram-logo.png';
import { FULL_PRODUCTS } from '../../data/Products.js';
import { MISC } from '../../data/Misc.js';
import {Link, useHistory} from 'react-router-dom';

function Footer(){
    const history = useHistory();
    return <footer>
        <div className="footer-content-container">
            <ul className="footer-menu-list-container">
                <li><Link to="/productos">Productos</Link></li>
                <li>Varios</li>
                <li>Consejos</li>
                <li className="footer-rrss-logos">
                    <img src={logoFacebook} alt="" height="20px" width="20px"/>
                    <img src={logoInstagram} alt="" height="20px" width="20px"/>
                </li>
            </ul>
            <ul className="footer-menu-list-desktop">
                <li><Link to="/productos">Productos</Link>
                    <ul className="footer-list-products">
                        {FULL_PRODUCTS.map(n => <li><Link to={`/productos/${n.id}`}>{n.title}</Link></li>)}
                    </ul>
                </li>

                <li><Link to="/varios">Varios</Link>
                    <ul className="footer-list-products">
                        {MISC.map(m => <li><Link to={`/varios/${m.id}`}>{m.title}</Link></li>)}
                        <li><Link to="/varios">Más</Link></li>
                    </ul>
                </li>
                <li><Link to="/consejos">Consejos</Link></li>
                <li><Link to="/">Inicio</Link></li>
            </ul>
            <img src={logo} onClick={()=>history.push('/')}/>
        </div>
        <ul className="footer-team-info">
            <li>Diseñado por <strong id="designer-name"><a href="https://www.behance.net/leozingaretti/" target="_blank">Leónidas</a></strong></li>
        </ul>
    </footer>
}

export default Footer;